import Conditional from 'decorators/conditional';
import Desktop from './index.desktop';

export default Conditional({
  desktop: Desktop,
});
